(ns app.domain.case-notes.model
  (:require [core.db.child-entity :as child]
            [core.user.model :as user-model]))

(def ^{:arglists '([phase])} phase-case-notes
  (child/child-entities-of-type-fn :entity.type/case-note))

(defn note->latest-change-timestamp
  [note]
  (or (some-> note :latest-change :ts)
      (-> note :entity/created)))

(defn note->latest-change-user
  [note]
  (or (some-> note :latest-change :user)
      (-> note :entity/creator user-model/full-name)))
